export class ScrollingAnimation {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        heroTeaserNotAnimated: '.hero-teaser:not(.hero-teaser--animate)',
        bigSearchTeaserNotAnimated: '.big-header-teaser:not(.big-header-teaser--animate)',
        teaserGroupItemNotAnimated: '.teaser-group__item:not(.teaser-group__item--animate)',
        newsListItemNotAnimated: '.news-list--boxes .news-list__item:not(.news-list__item--animate)',
        pageTopImageNotAnimated: '.page__top-image:not(.page__top-image--animate)',
        advantageCalculatorSummary: '.advantage-calculator__summary-price:not(.advantage-calculator__summary-price--animate)'
      },
      classes: {
        heroTeaserAnimated: 'hero-teaser--animate',
        bigSearchTeaserAnimated: 'big-header-teaser--animate',
        teaserGroupItemAnimated: 'teaser-group__item--animate',
        newsListItemAnimated: 'news-list__item--animate',
        pageTopImageAnimated: 'page__top-image--animate',
        advantageCalculatorSummaryAnimated: 'advantage-calculator__summary-price--animate'
      },
      screenPositionTop: 0,
      screenPositionBottom: 0
    },
    settings)
  }

  init () {
    const that = this
    let resizeTimer

    // Change header on scrolling
    $(document)
      .scroll(function () {
        that.checkScrolling()
      })

    $(window)
      .resize(function () {
        clearTimeout(resizeTimer)

        resizeTimer = setTimeout(function () {
          that.checkScrolling()
        })
      })

    that.checkScrolling()
  }

  checkScrolling () {
    const that = this

    that.options.screenPositionTop = $(document).scrollTop()

    that.options.screenPositionBottom = that.options.screenPositionTop + $(window).height()

    // Hero teaser
    that.setElementAnimation(that.options.selectors.heroTeaserNotAnimated, that.options.classes.heroTeaserAnimated)

    // Big search teaser
    that.setElementAnimation(that.options.selectors.bigSearchTeaserNotAnimated, that.options.classes.bigSearchTeaserAnimated)

    // Teaser group item
    that.setElementAnimation(that.options.selectors.teaserGroupItemNotAnimated, that.options.classes.teaserGroupItemAnimated)

    // News list item
    that.setElementAnimation(that.options.selectors.newsListItemNotAnimated, that.options.classes.newsListItemAnimated)

    // Page top image
    that.setElementAnimation(that.options.selectors.pageTopImageNotAnimated, that.options.classes.pageTopImageAnimated)

    // Advantage calculator summary
    that.setElementAnimation(that.options.selectors.advantageCalculatorSummary, that.options.classes.advantageCalculatorSummaryAnimated)
  }

  setElementAnimation (elementSelector, animationClass) {
    const that = this

    $(elementSelector)
      .each(function () {
        const element = $(this)

        if (element.is(':visible')) {
          const elementPositionTop = element.offset().top

          const elementPositionBottom = elementPositionTop + element.height()

          if ((elementPositionTop > that.options.screenPositionTop && elementPositionTop < that.options.screenPositionBottom) ||
              (elementPositionBottom > that.options.screenPositionTop && elementPositionBottom < that.options.screenPositionBottom)) {
            element
              .addClass(animationClass)
          }
        }
      })
  }
}

export default ScrollingAnimation
